export const initialState = {
  landingPageCompletionMetrics: [],
  filteredLandingPageCompletionMetrics: [],
  isLoading: false,
  searchText: "",
  filterModel: {},
  hasError: false,
  errorMessage: "",
  landingPageResponseData: null,
  isResponseModalOpen: false
};